import {Dialog} from 'primereact/dialog';
import {TabPanel, TabView} from 'primereact/tabview';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import {Document, Page, pdfjs} from 'react-pdf';
import ActionButton from '../components/ActionButton';
import DivContainer from '../components/DivContainer';
import AccountService from '../services/AccountService';
import AuthService from '../services/AuthService';
import { saveAs } from 'file-saver';
const url = `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
pdfjs.GlobalWorkerOptions.workerSrc = url;

class ApprovalsAcceptationDialog extends React.Component {
    constructor(props) {
        super(props);
        this.service = new AccountService();
        this.authService = new AuthService();
        let agreementTermList = [];
        if (props.approvals != null && props.approvals) {
            agreementTermList = props.approvals;
        }
        this.state = {
            acceptedTermsList: this.authService.getHighwaysAcceptedTerms(),
            notAcceptedTermsList: [],
            agreementTermList: agreementTermList,
            activeIndex: 0,
            pageNumber: 1,
            numPages: 0,
        };
        this.onDocumentLoadSuccess = this.onDocumentLoadSuccess.bind(this);
        this.handleAccept = this.handleAccept.bind(this);
        this.handleTabChangeAgreementDialog = this.handleTabChangeAgreementDialog.bind(this);
    }

    blockUi(callBack, waitPanelLabel) {
        this.props.blockUi(callBack, waitPanelLabel);
    }

    unblockUi(callBack) {
        this.props.unblockUi(callBack);
    }
    tabPanelLabel(product) {
        const {t} = this.props;
        return (
            <div>
                <span>{product.title} </span>
                <img
                    id={`id-agreement-icon-${product.name}`}
                    className='card-icon'
                    alt={t('order-card.agreementForPetrol')}
                    src={`/images/${
                        this.state.acceptedTermsList.includes(product.petraAgreementId)
                            ? 'ico_agreement_active'
                            : 'ico_agreement_inactive'
                    }.svg`}
                />
            </div>
        );
    }

    render() {
        const {className, id, key, name, onHide, visible,t} = this.props;
        return (
            <Dialog
                ariaCloseIconLabel={this.translate('dialog.closeDialog')}
                header={this.renderHeader()}
                footer={this.renderFooter()}
                visible={visible} 
                className={className}
                key={`${key ? key : id ? id : name}-dialog`}
                onHide={() => (onHide ? onHide() : null)}
                closable={false}
            >
                <form onSubmit={this.handleFormSubmit} noValidate onKeyDown={(e) => this.onKeyDown(e)}>
                    <TabView
                        className='agreement-term-tab-view'
                        activeIndex={this.state.activeIndex}
                        onTabChange={this.handleTabChangeAgreementDialog}
                    >
                        {this.props.approvals
                            ? this.props.approvals.map((at) => {
                            const fileUrl =  at.contents?.filter(el => el.type === "LINK")[0]?.linkUrl;
                            const segments = new URL(fileUrl).pathname.split('/');
                            const fileName = segments.pop() || segments.pop(); 

                                  return (
                                      <TabPanel header={this.tabPanelLabel(at)} key={`agreement-term-${at.approvalType}`}>
                                          <Document
                                              file={`${process.env.REACT_APP_BACKEND_URL}/account/agreement-terms-download/${fileName}`}
                                              onLoadSuccess={this.onDocumentLoadSuccess}
                                          >
                                              <Page
                                                  key={`page_${this.state.pageNumber}`}
                                                  pageNumber={this.state.pageNumber}
                                                  //   width={containerWidth ? Math.min(containerWidth, maxWidth) : maxWidth}
                                                  renderTextLayer={false}
                                                  renderAnnotationLayer={false}
                                                  scale={1.63}
                                              />
                                          </Document>
                                      </TabPanel>
                                  );
                              })
                            : null}
                    </TabView>
                </form>
            </Dialog>
            // </BlockUi>
        );
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    renderFooter() {
        const {t} = this.props;
        return (
            <div className='footer-dialog-button-container'>
                <ActionButton
                    label={t('productAgreements.prevPage')}
                    variant={'button cancel-button white'}
                    disabled={this.state.pageNumber <= 1}
                    handleClick={() => {
                        this.setState((prevState) => ({
                            pageNumber: prevState.pageNumber - 1,
                        }));
                    }}
                />
                <ActionButton
                    label={t('productAgreements.nextPage')}
                    variant={'button cancel-button white'}
                    disabled={this.state.pageNumber >= this.state.numPages}
                    handleClick={() => {
                        this.setState((prevState) => ({
                            pageNumber: prevState.pageNumber + 1,
                        }));
                    }}
                />
                <ActionButton
                    label={t('productAgreements.agree')}
                    variant={'button cancel-button white'}
                    // disabled={
                    //     this.state.pageNumber < this.state.numPages ||
                    //     this.state.acceptedTermsList.includes(this.state.agreementTermList[this.state.activeIndex].petraAgreementId)
                    // }
                    handleClick={() => {
                        this.handleAccept(this.state.agreementTermList[this.state.activeIndex]);
                    }}
                />
                <ActionButton
                    label={t('productAgreements.close')}
                    variant={'button cancel-button blue'}
                    handleClick={(e) => {
                        this.props.onHide(this.state.acceptedTermsList);
                    }}
                /> 
                        <ActionButton
                         label={t('productAgreements.download')}
                         variant={'button cancel-button blue'}
                         handleClick={() => {                    
                            let fileName =  this.state.agreementTermList[this.state.activeIndex].fileName;
                           // e.preventDefault();
                            this.service
                                            .getAgreementTermFile(fileName)
                                            .then((response) => {
                                                saveAs(response, `${fileName}`);
                                                this.unblockUi();
                                            })
                                            .catch((err) => {
                                                this.props.showErrorMessage(t('productAgreements.downloadPdfError'));
                                                this.unblockUi();
                                            });
                                    }
                             
                        }
                    />
            </div>
        );
    }

    renderHeader() {
        const {t} = this.props;
        return (
            <DivContainer colClass='col-12 transaction-dialog-header'>
                <DivContainer colClass='col-12'>
                    <label>{t('productAgreements.dialogHeaderTitle')}</label>
                </DivContainer>
            </DivContainer>
        );
    }

    onDocumentLoadSuccess(a, b, c) {
        console.log('onDocumentLoadSuccess', a, b, c);
        this.setState((prevState) => ({
            pageNumber: 1,
            numPages: a.numPages,
        }));
    }

    handleTabChangeAgreementDialog(e) {
        this.setState((prevState) => ({
            activeIndex: e.index,
            readTerms: false,
            pageNumber: 1,
            numPages: 0,
        }));
    }
    checkTokenIfAllHybridAgreementNotAccepted(){
        const listOfAcceptedTerms = this.authService.getHighwaysAcceptedTerms();
        return this.props.approvals.filter(el => !listOfAcceptedTerms.includes(el.petraAgreementId)).length > 0;
    }

    handleAccept(product) {
        const {t} = this.props;
        // this.blockUi();
        console.log('handleAccept', product);
        this.service
            .acceptHybridCardUserApproval(product.petraAgreementId)
            .then((response) => {
                // this.unblockUi(() => {
                if (response.token) {
                    this.authService.setToken(response.token);
                }
                if (response.result) {
                    let arrayWithAcceptedTerms = [...this.state.acceptedTermsList]; 
                    if (
                        !arrayWithAcceptedTerms.includes(product.petraAgreementId) &&
                        product.petraAgreementId !== undefined &&
                        product.petraAgreementId !== null
                    ) {
                        arrayWithAcceptedTerms.push(product.petraAgreementId);
                    }
                    if(this.checkTokenIfAllHybridAgreementNotAccepted() === false){
                        this.props.onHide(); 
                    }
                    this.setState({
                        acceptedTermsList: arrayWithAcceptedTerms,
                    });
                }
            })
            .catch(() => {
                // this.props.onHide();
                this.props.showErrorMessage(t('error.isAgreementTermAcceptedError')); //do poprawy -blad show error message
            });
    }
}

ApprovalsAcceptationDialog.defaultProps = {
    currentUser: undefined,
    visible: false,
    embedded: true,
    viewMode: 'VIEW',
    style: {width: '30vw'},
};

ApprovalsAcceptationDialog.propTypes = {
    approvals: PropTypes.array,
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    currentUser: PropTypes.object,
    editUrl: PropTypes.string,
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    cardNumbers: PropTypes.array,
    unblockUi: PropTypes.func,
    blockUi: PropTypes.func,
    showSuccessMessage: PropTypes.func,
    showErrorMessage: PropTypes.func,
};

export default withTranslation()(ApprovalsAcceptationDialog);